// extracted by mini-css-extract-plugin
export default {"box":"couponFilterPage_box__S6LFx","box__content__dropdown":"couponFilterPage_box__content__dropdown__5DLZp","box__btn":"couponFilterPage_box__btn__ih+Vp"};